import React, {Component} from "react";
import InventoryUnit from "./components/InventoryUnit";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../../modules/commons/Container";
import InventoryPage from "./common/InventoryPage";

class InventoryStock extends Component {
    contents = [
        {
            title: "Unit",
            component: <InventoryUnit menuAccess={this.props.menuAccess}/>
        },
        {
            title: "KSU",
            component: <InventoryPage menuAccess={this.props.menuAccess} type="ksu"/>
        },
        {
            title: "Hadiah",
            component: <InventoryPage menuAccess={this.props.menuAccess} type="hadiah"/>
        },
        {
            title: "Barang Lain",
            component: <InventoryPage menuAccess={this.props.menuAccess} type="otherItem"/>
        }
    ]


    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        {this.contents.map((content, index) => (
                            <Tab
                                key={content.title + index}
                                id={`btn_navigate_${content.title}`}
                            >
                                {content.title}
                            </Tab>
                        ))}
                    </TabList>
                    {this.contents.map((content, index) => (
                        <TabPanel key={content.title + index}>{content.component}</TabPanel>
                    ))}
                </Tabs>
            </Container>
        );
    }
}

export default InventoryStock;